import { isVue2, h as h$1, Vue2, defineComponent } from 'vue-demi';
import Picker from 'emoji-picker-element/picker';
import Database from 'emoji-picker-element/database';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const adaptOnsV3 = (ons) => {
    if (!ons)
        return null;
    return Object.entries(ons).reduce((ret, [key, handler]) => {
        key = key.charAt(0).toUpperCase() + key.slice(1);
        key = `on${key}`;
        return Object.assign(Object.assign({}, ret), { [key]: handler });
    }, {});
};
const h = (type, options = {}, chidren) => {
    if (isVue2)
        return h$1(type, options, chidren);
    const { props, domProps, on } = options, extraOptions = __rest(options, ["props", "domProps", "on"]);
    let ons = adaptOnsV3(on);
    const params = Object.assign(Object.assign(Object.assign(Object.assign({}, extraOptions), props), domProps), ons);
    return h$1(type, params, chidren);
};

function isDarkMode() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function toDashes(key) {
    return key.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
}

if (Vue2) {
    Vue2.config.ignoredElements.push('emoji-picker');
}
var VuemojiPicker = defineComponent({
    props: {
        isDark: {
            type: Boolean,
            required: false,
            default: isDarkMode()
        },
        skinToneEmoji: String,
        customEmoji: Array,
        dataSource: String,
        locale: String,
        customCategorySorting: Function,
        i18n: Object,
        pickerStyle: Object
    },
    emits: ['emojiClick', 'skinToneChange'],
    data: () => ({
        picker: new Picker()
    }),
    methods: {
        handleClick(event) {
            this.$emit('emojiClick', event.detail);
        },
        handleSkinToneChange(event) {
            this.$emit('skinToneChange', event.detail);
        },
        updatePickerProps() {
            const { skinToneEmoji, dataSource, locale, customEmoji, i18n, customCategorySorting, isDark } = this.$props;
            if (skinToneEmoji) {
                this.picker.skinToneEmoji = skinToneEmoji;
            }
            if (dataSource) {
                this.picker.dataSource = dataSource;
            }
            if (locale) {
                this.picker.locale = locale;
            }
            if (customEmoji) {
                this.picker.customEmoji = customEmoji;
            }
            if (i18n) {
                this.picker.i18n = i18n;
            }
            if (customCategorySorting) {
                this.picker.customCategorySorting = customCategorySorting;
            }
            this.picker.classList.toggle('dark', isDark);
            this.picker.classList.toggle('light', !isDark);
            this.updatePickerStyle();
        },
        updatePickerStyle() {
            if (this.pickerStyle && typeof this.pickerStyle === 'object') {
                Object.keys(this.pickerStyle).forEach((key) => {
                    var _a, _b;
                    if (key === 'height' && ((_a = this.pickerStyle) === null || _a === void 0 ? void 0 : _a.height)) {
                        this.picker.style.setProperty('height', this.pickerStyle.height);
                    }
                    else if (key === 'width' && ((_b = this.pickerStyle) === null || _b === void 0 ? void 0 : _b.width)) {
                        this.picker.style.setProperty('width', this.pickerStyle.width);
                    }
                    else {
                        this.picker.style.setProperty(`--${toDashes(key)}`, this.pickerStyle[key]);
                    }
                });
            }
        }
    },
    mounted() {
        const root = this.$refs.root;
        this.updatePickerProps();
        root.appendChild(this.picker);
        this.picker.addEventListener('emoji-click', this.handleClick);
        this.picker.addEventListener('skin-tone-change', this.handleSkinToneChange);
    },
    beforeUnmount() {
        this.picker.removeEventListener('emoji-click', this.handleClick);
        this.picker.removeEventListener('skin-tone-change', this.handleSkinToneChange);
    },
    watch: {
        $props: {
            handler() {
                this.updatePickerProps();
            },
            deep: true
        }
    },
    render() {
        return h('div', {
            ref: 'root'
        });
    }
});

function useDatabase() {
    return new Database();
}

export { VuemojiPicker, useDatabase };
//# sourceMappingURL=vuemoji-picker.esm.js.map
